import { Box, Typography, useTheme } from "@mui/material";
import { memo } from "react";
import BrandAvatar from "~src/components/BrandAvatar";
import { TrendingAd } from "~src/types/ad";

const HeaderComponent = ({ ad }: { ad: TrendingAd }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: 64,
        width: "100%",
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        p: 2,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
      data-testid="fb-ads-tile-header"
    >
      <Box
        component="a"
        href={`/brands/${ad.brand_id}/overview`}
        sx={{
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
          color: "inherit",
        }}
        onClick={(e) => {
          // Prevent event bubbling to avoid triggering the parent tile's click event
          e.stopPropagation();
        }}
      >
        <BrandAvatar
          brandName={ad.brand_name}
          profileImage={ad.profile_image}
          size={32}
          sx={{
            border: `1px solid ${theme.palette.grey[300]}`,
            mr: 2,
          }}
          data-testid="fb-ads-tile-image"
        />
        <Typography variant="subtitle2" data-testid="fb-ads-tile-brand-name">
          {ad.brand_name}
        </Typography>
      </Box>
    </Box>
  );
};

// Memoize to prevent re-renders when parent updates
export const Header = memo(HeaderComponent);
